<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      reactiveData: {}
    };
  },
  created() {
    Object.keys(this.data).forEach(key => {
      this.$set(this.reactiveData, key, this.data[key]);
    });
  }
};
</script>
<template>
  <div>
    <slot v-bind="reactiveData"></slot>
  </div>
</template>
